module.exports = __webpack_public_path__ + "static/media/5-1.9e8f3148.webp";